'use strict';

import axios from 'axios';
import {
  createElement,
  listenDOMEvent,
  appendElementContent
} from '@jspartials/dom-api-utils';
import { startSpinner, stopSpinner } from '@jscomponents/spinner';
import { updateUrlLink } from '@jspartials/filter-utils';
import { listenButtonShowMore } from '@jspages/search/loadMoreProducts';
import {
  gtmListenProductTiles,
  gtmLaunchApplySorting
} from '@jspartials/gtm-utils';
import { customEvent } from '@jspartials/general-utils';
import { listenImagesCarousel } from '@jspages/search/imagesCarouselTiles';

// Selectors
const selector = {
  wrapper: {
    gridProducts: '.js-grid-products',
    gridFooter: '.js-grid-footer'
  },
  sortingButton: '.js-sorting-button'
};

// Elements
const element = {
  wrapper: {
    gridProducts: document.querySelector(selector.wrapper.gridProducts) || null
  }
};

// Variables
const eventReloadVtoButtons = new CustomEvent(customEvent.reloadVtoButtons);
const eventListenProductTiles = new CustomEvent(customEvent.listenProductTiles);
const eventInitProductTilesAnimation = new CustomEvent(
  customEvent.initProductTilesAnimation
);

// Functions

/**
 * Update sort option URLs from Ajax response
 * @param {String} response - HTML code
 * @return {void}
 */
function updateSortUrls(response) {
  const temporalElement = createElement({
    tag: 'div',
    content: response
  });
  const gridFooterElement =
    temporalElement.querySelector(selector.wrapper.gridFooter) || null;
  const sortOptions = gridFooterElement?.dataset?.sortOptions
    ? JSON.parse(gridFooterElement.dataset.sortOptions)
    : {};
  const options = 'options' in sortOptions ? sortOptions.options : [];

  options.forEach((option) => {
    const optionElement =
      document.querySelector(
        `${selector.sortingButton}[data-id="${option.id}"]`
      ) || null;

    if (optionElement) {
      optionElement.dataset.value = option.url;
    }
  });
}

/**
 * Listen the sorting buttons
 * @returns {void}
 */
const listenSortingButtons = () => {
  const sortingButton = document.querySelector(selector.sortingButton) || null;

  if (sortingButton) {
    listenDOMEvent(sortingButton, 'change', () => {
      sortProducts(sortingButton);
    });
  }
};

/**
 * Sort products
 * @returns {void}
 */
const sortProducts = (element) => {
  const currentSortingOption = element.options[element.selectedIndex];
  const url = currentSortingOption?.dataset?.value || null;
  const label = currentSortingOption.text.trim();
  const sortingRuleId = currentSortingOption?.dataset?.sortingRuleId;

  if (url) {
    startSpinner();

    gtmLaunchApplySorting(label, sortingRuleId);

    axios
      .get(url)
      .then((response) => {
        paintNewContent(response.data);
        listenImagesCarousel();
        updateUrlLink();
        listenButtonShowMore();
        gtmListenProductTiles(true);
        document.dispatchEvent(eventListenProductTiles);
        document.dispatchEvent(eventReloadVtoButtons);
        document.dispatchEvent(eventInitProductTilesAnimation);
      })
      .catch((error) => {
        console.error(error);
      })
      .then(() => {
        stopSpinner();
      });
  }
};

/**
 * Paint new content
 * @param {String} content - Content to paint
 * @returns {void}
 */
const paintNewContent = (content) => {
  if (element.wrapper.gridProducts) {
    appendElementContent(element.wrapper.gridProducts, content);
  }
};

export { updateSortUrls, listenSortingButtons };
